import {vars} from "../config"
import {cookie} from "../utils"
import env from "../env"

export default state => {
  const languages =
    typeof env.LANGUAGES !== "undefined" ? env.LANGUAGES : ["de", "en", "zh-Hans", "zh-Hant"]

  const langAvailable =
    typeof state.router.params.lang !== "undefined"
      ? languages.includes(state.router.params.lang)
      : false

  if (!langAvailable) {
    const defaultLangCookie = cookie.get(vars.defaultLangCookieName)
    const defaultLang =
      defaultLangCookie.length === 0 ? vars.defaultLang : defaultLangCookie

    return defaultLang
  }

  return state.router.params.lang
}



// WEBPACK FOOTER //
// ./src/utils/getLang.js